import React, { useState } from "react";
import { func } from 'prop-types';

import css from './AboutUsPage.module.css';
import { updateProfile } from '../ProfileSettingsPage/ProfileSettingsPage.duck';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { LayoutSingleColumn, Page } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import { isScrollingDisabled } from '../../ducks/ui.duck';

import {
  QuestionOutlined,
} from '@ant-design/icons';
import { Button } from 'antd';
import about from './img/about.jpg';
import employers from './img/employers.png';
import fake from './img/fake.png';
import job from './img/job.png';
import opportunities from './img/opportunities.png';
import partners from './img/partners.png';
import teams from './img/teams.png';
import trustworthy from './img/trustworthy.png';
import truth from './img/truth.png';
import unprotected from './img/unprotected.png';
import vendor from './img/vendor.png';
import { createResourceLocatorString } from "../../util/routes";
import { useRouteConfiguration } from "../../context/routeConfigurationContext";
import { useHistory } from "react-router-dom";


function AboutUsPage(props) {

  const { onUpdateProfile, params, scrollingDisabled } = props;

  const [activeCard, setActiveCard] = useState(0); // First card active by default

  const cards = [
    {
      img: job,
      title: "Job Seekers",
      description: "To prove their worth with verified, protected profiles",
    },
    {
      img: employers,
      title: "Employers",
      description: "To hire with confidence, speed, and accuracy",
    },
    {
      img: partners,
      title: "Implementation Suppliers",
      description: "To access high-value RFPs and showcase what sets them apart",
    },
    {
      img: teams,
      title: "Procurement Teams",
      description: "To make informed, unbiased decisions with total transparency",
    },
  ];

  const history = useHistory();
  const routeConfiguration = useRouteConfiguration();
  
  const redirectToSignupPage = () => {
    history.push(createResourceLocatorString('SignupPage', routeConfiguration, {}));
  };

  return (
    <Page title={'About'} scrollingDisabled={scrollingDisabled}>
      <LayoutSingleColumn
        sideNavClassName={css.navigation}
        topbar={
          <TopbarContainer
            mobileRootClassName={css.mobileTopbar}
            desktopClassName={css.desktopTopbar}
          />
        }
        footer={<FooterContainer />}
      >
        <div className={css.aboutContainer}>
          <div className={css.aboutIntro}>
            <div className={css.aboutLeft}>
              <img src={about} />
            </div>
            <div className={css.aboutRight}>
              <h1>About <span>Us</span></h1>
              <p>
                At iParley, we're transforming the way talent, suppliers, and enterprises connect— with a
                foundation built on being <strong>Trusted, True, and Transparent</strong>. iParley is
                more than just a platform—it's a movement toward {' '}
                <strong>integrity-driven hiring and supplier selection</strong>. In a world filled with
                noise, inflated resumes, and hidden agendas, we create clarity.
              </p>
              <p>
                We built iParley to solve the challenges that traditional staffing platforms and
                procurement systems overlook:
              </p>
            </div>
          </div>
          <div className={css.aboutFeatures}>
            <div className={css.aboutLeft}>
              <h3>Fake profiles? <span>Not here.</span></h3>
              <p>Every candidate and supplier is verified.</p>
            </div>
            <div className={css.aboutRight}>
              <img src={fake} />
            </div>
          </div>
          <div className={css.aboutFeatures}>
            <div className={css.aboutLeft}>
              <img src={vendor} />
            </div>
            <div className={css.aboutRight}>
              <h3>Supplier bias? <span>Removed.</span></h3>
              <p>Enterprises can access and compare from a broad, vetted network.</p>
            </div>
          </div>
          <div className={css.aboutFeatures}>
            <div className={css.aboutLeft}>
              <h3>Unprotected data? <span>Never.</span></h3>
              <p>Sensitive information stays secure and in your control.</p>
            </div>
            <div className={css.aboutRight}>
              <img src={unprotected} />
            </div>
          </div>
          <div className={css.aboutServices}>
            <h2>Our platform empowers</h2>

            <div className={css.aboutServicesContainer}>
              {cards.map((card, index) => (
                <div
                  key={index}
                  className={`${css.aboutServicesBlock} ${activeCard === index ? css.active : ""}`}
                  onMouseEnter={() => setActiveCard(index)}
                >
                  <img src={card.img} alt={card.title} />
                  <h4>{card.title}</h4>
                  <p>{card.description}</p>
                </div>
              ))}
            </div>

          </div>
          <div className={css.aboutHero}>
            <p>
              At iParley, we don't just facilitate connections —
              we build trustworthy partnerships,
              create real opportunities,
              and ensure that every transaction is rooted in truth.
            </p>
          </div>
          <div className={css.aboutCTA}>
            <p>Because in today's world, trusted, true, and transparent isn't just a tagline. It's the standard.</p>
            <Button size='large' onClick={()=>redirectToSignupPage()}>Get Started</Button>
          </div>
        </div>
      </LayoutSingleColumn>
    </Page>
  );
}
AboutUsPage.propTypes = {
  // onCreateCredentials: func.isRequired,
  onUpdateProfile: func.isRequired,
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const mapDispatchToProps = dispatch => ({
  // onCreateCredentials: data => dispatch(createCredentials(data)),
  onUpdateProfile: data => dispatch(updateProfile(data)),
});

export default AboutUsPage = compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl
)(AboutUsPage);
